import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Map = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="map icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.21216 5.43622C1.47679 5.75137 1 6.47445 1 7.27451V18.9226C1 20.3585 2.4681 21.3265 3.78784 20.7609L7.26186 19.2721C7.73557 19.069 8.26937 19.0567 8.75194 19.2377L15.2481 21.6737C15.7306 21.8547 16.2644 21.8424 16.7381 21.6394L21.7878 19.4752C22.5232 19.1601 23 18.437 23 17.6369V5.98879C23 4.55296 21.5319 3.5849 20.2122 4.1505L16.7381 5.63937C16.2644 5.84239 15.7306 5.8547 15.2481 5.67374L8.75194 3.23769C8.26937 3.05673 7.73557 3.06904 7.26186 3.27206L2.21216 5.43622ZM9 16.2627V6.39871L15 8.64871V18.5127L9 16.2627Z"
    />
  </svg>
)
